import { ArrowRight, Clock, MousePointer2, UserRound } from "lucide-react";

function IllustratedTask({ title, age, className }: {
  title: string;
  age: string;
  className: string;
}) {
  return (
    <div className={`absolute w-[210px] rounded-lg border border-neutral-200 border-l-[3px] border-l-neutral-400 bg-white p-3 text-left shadow-[0_12px_24px_-10px_rgb(0_0_0/0.18)] ${className}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="text-xs font-semibold text-neutral-900">{title}</span>
        <span className="rounded-full bg-neutral-100 px-1.5 py-0.5 text-[9px] text-neutral-600">Media</span>
      </div>
      <div className="mt-0.5 text-[10px] text-neutral-500">Proceso</div>
      <div className="mt-2 inline-flex items-center gap-1 rounded-md bg-neutral-100 px-1.5 py-0.5 text-[9px] text-neutral-600">
        <UserRound size={10} /> Asignada
      </div>
      <div className="mt-2 flex items-center justify-between text-[10px] text-neutral-500">
        <span className="flex items-center gap-1"><Clock size={12} />{age}</span>
        <ArrowRight size={12} />
      </div>
    </div>
  );
}

export function TaskSelectionIllustration() {
  return (
    <div aria-hidden="true" className="pointer-events-none relative h-[240px] w-[440px] shrink-0 select-none">
      <div className="absolute left-[110px] top-1 size-[220px] rounded-full border border-dashed border-neutral-300" />
      <div className="absolute left-[116px] top-2 size-3 rounded-full border-2 border-neutral-400" />
      <div className="absolute bottom-2 right-[112px] size-3 border border-neutral-400" />
      <IllustratedTask title="Validar documento" age="Hace 5 días" className="left-2 top-12 -rotate-10" />
      <IllustratedTask title="Aprobar solicitud" age="Hace 3 días" className="right-2 top-12 rotate-10" />
      <IllustratedTask title="Revisar tarea" age="Hace 2 días" className="left-[115px] top-[100px]" />
      <MousePointer2 className="absolute bottom-9 right-[99px] size-8 fill-neutral-950 text-white drop-shadow-sm" strokeWidth={1.5} />
    </div>
  );
}
